/* Used for push notifications, cookies and popups. */
import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import Transition from 'react-transition-group/Transition';
import Newsletter from '../Footer/Newsletter';
import { addEvent, removeEvent, purifier } from '../../utils/dom';
import { isRestricted } from '../../utils/restrict';
import { urlify, translate } from '../../utils/string';
import s from './Notification.scss';

class Notification extends Component {
	constructor(props) {
		super(props);

		this.notificationInner = React.createRef();
		this.notificationClose = React.createRef();
	}

	componentDidMount() {
		addEvent(document.querySelector('body'), 'click.notificationClose', (e) => {
			if (this.notificationInner.current && !this.notificationInner.current.contains(e.target) && this.props.type === 'popup') {
				e.preventDefault();
				e.stopPropagation();
				this.removeNotificationHandler(e);
			}
		});
	}

	componentWillUnmount() {
		removeEvent(document.querySelector('body'), 'click.notificationClose');
	}

	removeNotificationHandler = (e) => {
		if (e) e.preventDefault();

		const $notificationElement = this.notificationInner.current;
		const cookieName = $notificationElement.dataset.name;
		const cookieDuration = $notificationElement.dataset.duration;

		let date = new Date();
		date = date.setTime(date.getTime() + (cookieDuration * 1000));

		const expires = `expires=${new Date(date).toGMTString()}; `;

		document.cookie = `${cookieName}=1; ${expires}path=/`;

		// Notify Redux that we have removed the item.
		this.props.notificationRemoved();
		this.props.removeNotification(this.props.type, cookieName);
	}

	newsletterSubmitHandler = () => {
		setTimeout(() => {
			this.removeNotificationHandler();
		}, 500);
	}

	render() {
		const { type, content, setup } = this.props;

		const notifications = (content || []).filter((n) => {
			const notificationName = urlify(n.name);
			if (n.countryRestrict && isRestricted(setup, { selectedCountries: n.countryRestrict })) return false;
			if (!n.active && type === 'popup') return false;
			// Check for cookies which are already set.
			if ((n.removable || type === 'popup') && n.cookieDuration) {
				let cookieIsSet = false;

				const cookies = typeof document !== 'undefined' ? document.cookie : setup.cookies;
				if (typeof cookies === 'object') {
					if (cookies[notificationName]) cookieIsSet = true;
				} else if (cookies) {
					cookies.split(';').forEach((cookie) => {
						// Cookie is set don't display notification.
						if (cookie.indexOf(notificationName) !== -1) cookieIsSet = true;
					});
				}

				// Still render notification if from server and cookie not set on page load.
				// This enables us to fade it out.
				if (cookieIsSet) return null;
			}
			if (n.content) {
				const hasContent = n.content.filter((c) => {
					if (c.countryRestrictContent && isRestricted(setup, { selectedCountries: c.countryRestrictContent })) return false;
					if (!c.text && !c.icon) return false;
					return true;
				});
				if (!hasContent || hasContent.length === 0) return false;
			}
			if (!n.content && !n.text) return false;
			return true;
		});

		if (notifications.length === 0) return null;

		return (
			<div className={[s.notification, s[`notification__${type}`]].join(' ')}>
				{
					notifications.map((item) => {
						const notificationName = urlify(item.name);
						const notificationAttributes = {
							style: {},
						};

						if (item.backgroundColor) notificationAttributes.style.backgroundColor = item.backgroundColor;
						if (item.color) notificationAttributes.style.color = item.color;

						// Check for cookies which are already set.
						if (item.removable && item.cookieDuration) {
							let cookieIsSet = false;

							const cookies = typeof document !== 'undefined' ? document.cookie : setup.cookies;
							if (typeof cookies === 'object') {
								if (cookies[notificationName]) cookieIsSet = true;
							} else if (cookies) {
								cookies.split(';').forEach((cookie) => {
									// Cookie is set don't display notification.
									if (cookie.indexOf(notificationName) !== -1) cookieIsSet = true;
								});
							}

							// Still render notification so we can fade it out.
							if (cookieIsSet && item.removed !== true) return null;

							notificationAttributes['data-name'] = notificationName;
							notificationAttributes['data-duration'] = item.cookieDuration;
						}

						return (
							<Transition in={item.removed !== true} timeout={300} key={notificationName} unmountOnExit>
								{(state) => (
									<div ref={this.notificationInner} className={[s.notification_inner, s[`notification_inner__${state}`], ...(item.removeText ? [s.notification_inner__closeText] : [])].join(' ')} {...notificationAttributes}>
										<span className={s.notification_inner_text} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, item.text)) }} />
										{
											item.cookieDuration && (
												<a className={s.notification_inner_close} href="#close" ref={this.notificationClose} onClick={this.removeNotificationHandler}>
													{
														item.removeText ? translate(setup, item.removeText) : (
															<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
																<g fill="none" fillRule="evenodd" strokeLinecap="square" strokeWidth="1.3" transform="translate(1 1)">
																	<path d="M0.405,0.409090909 L15.795,17.5909091" />
																	<path d="M0.405,0.409090909 L15.795,17.5909091" transform="matrix(-1 0 0 1 16.2 0)" />
																</g>
															</svg>
														)
													}
												</a>
											)
										}
										{
											item.includeNewsletter && <Newsletter callback={this.newsletterSubmitHandler} />
										}
									</div>
								)}
							</Transition>
						);
					})
				}
			</div>
		);
	}
}

export default hot(module)(Notification);
